import React from 'react'
import styled from 'styled-components'
import { MultiSelect as MS } from 'primereact/multiselect'
import colors from '../colors.scss'
import { useIntl } from 'react-intl'

const dropdownStyles = (props) => {
  if (props.dropdownStyle) {
    return `
      .p-multiselect-items {
        .p-multiselect-item {
          background-color: ${(props) => (props.theme === 'dark' ? colors.darkBackground : colors.white)};
          color: ${(props) => (props.theme === 'dark' ? colors.white : colors.invert)};

          &:hover:not(.p-disabled) {
            background-color: ${colors.primaryFaded};
            color: ${colors.white};
          }

          &.p-highlight {
            background-color: ${colors.primary};
            color: ${colors.white};
          }
        }
      }
    `;
  } else {
    return `
      .p-multiselect-items {
        .p-multiselect-item {
          color: ${colors.defaultInteractText};

          label {
            cursor: pointer;
          }

          &:not(.p-highlight):not(.p-disabled):hover {
            background-color: ${colors.white};
            color: ${colors.defaultInteractText};
          }

          &.p-highlight {
            background-color: ${colors.white};
            color: ${colors.defaultInteractText};
          }

          .p-checkbox-box.p-component {
            background-color: ${colors.white};

            &.p-highlight {
              background-color: ${colors.primary};
            }
          }
        }
      }
    `;
  }
};

export const MultiSelect = styled(({ ...props }) => {
  const intl = useIntl()
  return <MS selectedItemsLabel={intl.formatMessage({ id: 'common.items_selected' })} {...props} />
})`
  &&& {
    background-color: ${(props) => (props.dark ? colors.invert : colors.white)};
    border-radius: 20px;
    border: 2px solid ${(props) => (props.dark ? colors.invert : colors.white)};
    padding: ${(props) => (props.dropdownStyle ? "0 30px 0 20px" : "0 20px")};
    width: 100%;
    max-width: 243px !important;
    ${(props) => (props.dropdownStyle ? 'max-width: 243px !important;' : "")}

    .p-multiselect-trigger {
      color: ${colors.midGrey};
      background-color: transparent;
    }

    &:hover:not(.p-disabled) {
      border-color: ${(props) => (props.dark ? colors.invert : colors.white)};
    }

    &.p-focus {
      box-shadow: none;
      border-color: ${colors.primary};
    }

    .p-multiselect-panel {
      border-radius: 4px;
      border: none;

      .p-multiselect-items-wrapper {
        padding: ${(props) => (props.dropdownStyle ? 0 : "3px")} 0;
      }

      .p-checkbox {
        display: ${(props) => (props.dropdownStyle ? 'none' : "inline-block")};
      }

      .p-multiselect-header {
        border: none;
        background-color: ${colors.white};

        .p-multiselect-filter-container .p-inputtext {
          background-color: ${colors.white};
          color: ${colors.defaultInteractText};
        }

        .p-checkbox-box.p-component {
          background-color: ${colors.white};

          &.p-highlight {
            background-color: ${colors.primary};
          }
        }
      }

      ${(props) => dropdownStyles(props)}
    }

    .p-multiselect-header {
      display: ${(props) => (props.dropdownStyle ? 'none' : "block")};
    }

    .p-multiselect-label span + span::before {
      content: ", ";
    }

    .p-multiselect-label {
      background-color: ${(props) => (props.dark ? colors.invert : colors.white)};
      color: ${(props) => (props.dark ? colors.white : colors.defaultInteractText)};
      white-space: nowrap;
      margin: 0;
      ${(props) => (props.dropdownStyle ? 'padding: 9px 0px;' : "")}

      min-height: 33px;
      max-width: 600px;
    }

    @media screen and (max-width: 640px) {
      max-width: 250px;
    }
  }
`
